module.exports = __webpack_public_path__ + "static/media/usb@3x.cc811e06.png";